import { Resources, reports } from "./reportRedux";

const reportReducer = {
  reports
};

export { reportReducer, Resources };
